import { isDevMode } from '@angular/core';

export const devLog = (...args: unknown[]): void => {
    if (!isDevMode()) {
        return;
    }

    console.log(...args);
};
